import { db } from '../main'
import * as firebase from "firebase"
import router from '../router/index'
import axios from 'axios'
import {generateUUID} from '../mixins/utilities'

const GQL_ENDPOINT = "https://books-gql.herokuapp.com/v1alpha1/graphql";

const USERS_COLLECTION = 'students'
const DOWNLOADS_COLLECTION = 'downloads'
const GREETINGS_COLLECTION = 'Greetings'
const LESSONS_COLLECTION = 'lessons'
const SONGLISTS = 'songlists'
const DISALLOWED_DATES = 'disallowedDates'

export const signIn = ({ commit, dispatch }, user) => {
  commit('setLoading', true)
  firebase.auth().signInWithEmailAndPassword(user.email, user.password)
    .then(user => {
      commit('signIn')
      dispatch('getUserInfo', user.user.uid)
    }).catch(error => {
      commit('setLoading', false)
      commit('setError', error)
    })
}

export const getUserInfo = ({ commit, dispatch, state }, userId) => {
  const student = db.collection(USERS_COLLECTION).where('userId', '==', userId)

  student.onSnapshot(snap => {
    const student = []
    snap.forEach(doc => {
      student.push(doc.data())
    })
    commit('loadUser', student[0])
    dispatch('loadHandouts')
    dispatch('loadTracks')
    dispatch('loadNotes', userId)
    dispatch('loadFinalTracks')
    dispatch('loadGreetings')
    dispatch('loadStudents')
    dispatch('loadLessons')
    dispatch('loadDisallowedDates')
    dispatch('loadSonglists')
    dispatch('loadTargeted')
    state.user.userId === state.adminId ? router.replace('/admin') : router.replace('/')
    // state.user.userId === "Ogtb8B5Zltf8FKxx1sesQ2UW9852" ? router.replace('/songs'): ''
    commit('setLoading', false)
  })
}

export const loadHandouts = ({ commit }) => {
  const handouts = db.collection(DOWNLOADS_COLLECTION).where('type', '==', 'handouts')

  handouts.onSnapshot(snap => {
    const myHandouts = []
    snap.forEach(doc => {
      myHandouts.push({ docId: doc.id, ...doc.data() })
    })
    commit('loadHandouts', myHandouts)
  })
}

export const loadTracks = ({ commit }) => {
  const tracks = db.collection(DOWNLOADS_COLLECTION).where('type', '==', 'tracks')

  tracks.onSnapshot(snap => {
    const myTracks = []
    snap.forEach(doc => {
      myTracks.push({ docId: doc.id, ...doc.data() })
    })
    commit('loadTracks', myTracks)
  })
}

export const loadFinalTracks = ({ commit }) => {
  const finalTracks = db.collection(DOWNLOADS_COLLECTION).where('type', '==', 'final tracks')

  finalTracks.onSnapshot(snap => {
    const myFinalTracks = []
    snap.forEach(doc => {
      myFinalTracks.push({ docId: doc.id, ...doc.data() })
    })
    commit('loadFinalTracks', myFinalTracks)
  })
}

export const loadNotes = ({ commit, state }, userId) => {
  const isAdmin = state.adminId === state.user.userId
  let notes 
  if (isAdmin) {
    notes = db.collection(DOWNLOADS_COLLECTION)
    .where('type', '==', 'notes')
  } else {
    notes = db.collection(DOWNLOADS_COLLECTION)
    .where('type', '==', 'notes')
    .where('viewableBy', '==', userId)
  }


  notes.onSnapshot(snap => {
    let myNotes = []
    snap.forEach(doc => {
      if (doc.data.archived) {
        myNotes.push({ docId: doc.id, ...doc.data() })
      } else {
        myNotes.push({ docId: doc.id, archived: false, ...doc.data() })
      }

    })
    commit('loadNotes', myNotes)
    commit('setLoading', false)
  })
}

export const loadGreetings = ({ commit }) => {
  const greetings = db.collection('Greetings').orderBy('viewableBy')

  greetings.onSnapshot(snap => {
    const arrGreetings = []
    snap.forEach(doc => {
      arrGreetings.push({ docId: doc.id, ...doc.data() })
    })
    commit('loadGreetings', arrGreetings)
  })
}

export const loadStudents = ({ commit }) => {
  const students = db.collection(USERS_COLLECTION)

  students.onSnapshot(snap => {
    const arrStudents = []
    snap.forEach(doc => {
      arrStudents.push({ docId: doc.id, ...doc.data() })
    })
    commit('loadStudents', arrStudents)
  })
}

export const loadLessons = ({ commit }) => {
  const lessons = db.collection(LESSONS_COLLECTION)

  lessons.onSnapshot(snap => {
    const arrLessons = []
    snap.forEach(doc => {
      arrLessons.push({ docId: doc.id, ...doc.data() })
    })
    commit('loadLessons', arrLessons)
  })
}

export const loadDisallowedDates = ({ commit }) => {
  const lessons = db.collection(DISALLOWED_DATES)

  lessons.onSnapshot(snap => {
    const arrDisallowed = []
    snap.forEach(doc => {
      arrDisallowed.push({...doc.data() })
    })
    if (arrDisallowed.length > 0) {
      commit('loadDisallowedDates', arrDisallowed[0])
    }
  })
}

export const loadTargeted = ({ commit }) => {
  commit("setLoading", true);
  axios.post(GQL_ENDPOINT, {
    query:
      `
        {
          exercise_topics(order_by: {order: asc}) {
            id
            topic
            order
            targeted_exercises {
              title
              downloadURL
              id
            }
          }
        }
    `
  })
    .then(result => {
      const payload = result.data.data
      commit("loadTargeted", payload.exercise_topics)
      commit('setLoading', false)
    })
    .catch(err => {
      console.log(err);
    });
}

export const loadSonglists = ({ commit, state }) => {
  const isAdmin = state.adminId === state.user.userId
  let songlists 
  if (isAdmin) {
    songlists = db.collection(SONGLISTS)
  } else {
    songlists = db.collection(SONGLISTS)
    .where('user', '==', state.user.name)
  }
  songlists.onSnapshot(snap => {
    let mySonglist = []
    snap.forEach(doc => {
      mySonglist.push({ docId: doc.id, ...doc.data() })
    })
    if (isAdmin) {
      commit('loadSonglists', mySonglist)
    } else {
      commit('loadSonglist', mySonglist)
    }
    commit('setLoading', false)

  })
}

export const signUp = ({ commit, dispatch }, newUser) => {
  commit('setLoading', true)
  firebase.auth().createUserWithEmailAndPassword(newUser.email, newUser.password)
    .then(
      user => {
        commit('setLoading', false)
        commit('clearError')
        const currUser = {
          userId: user.user.uid,
          fname: newUser.fname,
          lname: newUser.lname,
          name: newUser.fname + ' ' + newUser.lname,
          email: newUser.email,
          password: newUser.password,
          added: new Date(),
          isActive: true
        }
        dispatch('addNewUser', currUser)
      }
    ).catch(error => {
      commit('setError', error)
      commit('setLoading', false)
    })
}

export const addNewUser = ({ commit }, currUser) => {
  db.collection(USERS_COLLECTION).add(currUser)
  router.replace('/')
}

export const updateUserStatus = ({ commit }, user) => {
  var entryRef = db.collection(USERS_COLLECTION).doc(user.documentId)

  return entryRef.update({
    isActive: !user.isActive
  })
    .then(() => {
      console.log("Document successfully updated!");
      router.push('/viewStudents')

    })
    .catch(error => {
      console.error("Error updating document: ", error);
    })
}

export const addNewDownload = ({ commit }, newDownload) => {
  db.collection(DOWNLOADS_COLLECTION).add(newDownload).then(() => {
    router.replace('/admin')
    commit('setLoading', false)
  })
}

export const addNewExercise = ({ commit, dispatch }, objExercise) => {
  axios
    .post(GQL_ENDPOINT, {
      query:
        `
        mutation insert_targeted_exercises {
          insert_targeted_exercises (objects: [{title: "${objExercise.title}", topic: "${objExercise.topic}", downloadURL: "${objExercise.downloadURL}"}]) 
          {
            returning {
              id
              title
              topic
              downloadURL
            }
          }
        }
      `
    })
    .then(() => {
      commit('setLoading', false)
      router.push('/admin')
    })
    .catch(err => console.log(err));
};

export const editItem = ({ commit }, item) => {
  db.collection(DOWNLOADS_COLLECTION).doc(item.docId).set(item);
  router.go(-1)
}

export const editStudent = ({ commit }, objStudent) => {
  db.collection(USERS_COLLECTION).doc(objStudent.docId).set(objStudent);
  router.push('/viewStudents')
}

export const deleteItem = ({ commit, dispatch, state }, item) => {
  db.collection(DOWNLOADS_COLLECTION).doc(item.docId).delete().then(function () {
    router.go(-1)
    console.log("Document successfully deleted!");
    if (state.type !== 'Greetings') {
      dispatch('deleteItemFromStorage', item)
    }
  }).catch(function (error) {
    router.replace('/admin')
    console.error("Error removing document: ", error);
  })
}

export const deleteItemFromStorage = ({ commit }, item) => {
  let strRef = 'downloads/' + item.type + '/' + item.name
  let storageRef = firebase.storage().ref(strRef);
  storageRef.delete().then(function () {
    console.log('File deleted!');
  }).catch(function (error) {
    console.log(error);
  })
}

export const addGreeting = ({ commit }, objItem) => {
  db.collection(GREETINGS_COLLECTION).add(objItem)
  router.replace('/viewItems')
}

export const setDisallowedDates = ({ commit, state }, arrDates) => {
  let objDates = {...arrDates}
  objDates.id = generateUUID()
  if (state.disallowedDates.length === 0) {
    db.collection(DISALLOWED_DATES).add(objDates).then(() => {
      commit('loadDisallowedDates', objDates)
      router.push('/admin')
    }).catch(function (error) {
        console.error("Error adding dates: ", error)
      })
  } else {
    db.collection(DISALLOWED_DATES).where("id", "==", state.disallowedDates.id)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            db.collection(DISALLOWED_DATES).doc(doc.id).update(objDates);
        });
        router.push('/admin')
     })
  }
}

export const deleteGreeting = ({ commit }, docId) => {
  db.collection(GREETINGS_COLLECTION).doc(docId).delete().then(() => {
    router.replace('/viewItems')
    console.log("Greeting successfully deleted!");
  }).catch(error => {
    router.replace('/viewItems')
    console.error("Error removing greeting: ", error);
  })
}

export const editGreeting = ({ commit }, greeting) => {
  db.collection(GREETINGS_COLLECTION).doc(greeting.docId).set(greeting);
  router.go(-1)
}

export const removeDisallowedDates = ({ commit, state}) => {
  const ID = state.disallowedDates.docId
  db.collection(DISALLOWED_DATES).doc(ID).delete().then(() => {
    router.replace('/admin')
    console.log("Dates successfully deleted!");
  }).catch(error => {
    router.replace('/admin')
    console.error("Error removing dates: ", error);
  })
}

export const setType = ({ commit }, type) => {
  commit('setType', type)
}

export const setLoading = ({ commit }, status) => {
  commit('setLoading', status)
}

export const setStudentName = ({ commit }, name) => {
  commit('clearStudentName')
  commit('setStudentName', name)
}

export const addLesson = ({ commit }, objLesson) => {
  const lessonToAdd = {
    studentId: objLesson.studentId,
    name: objLesson.name,
    date: objLesson.date,
    lessonTime: objLesson.lessonTime,
    timestamp: objLesson.timestamp
  }
  db.collection(LESSONS_COLLECTION).add(lessonToAdd).then(() => {
    axios.post('https://api.emailjs.com/api/v1.0/email/send', objLesson.data).then(() => {
    }).catch(error => {
      console.log(error);
    })
    router.replace('/lessonsDisplay')
  })
}

export const deleteLesson = ({ commit }, objLesson) => {
  db.collection(LESSONS_COLLECTION).doc(objLesson.docId).delete().then(() => {
    axios.post('https://api.emailjs.com/api/v1.0/email/send', objLesson.data).then(() => {
    }).catch(error => {
      console.log(error);
    })
  }).catch(error => {
    router.replace('/lessonsDisplay')
    console.error("Error removing lesson: ", error);
  })
}

// --------------- Songlists --------------

export const addNewSonglist = ({ commit }, objNewSonglist) => {
  const objSonglist = {
    name: objNewSonglist.name,
    songlistId: objNewSonglist.songlistId,
    user: objNewSonglist.user,
    songs: []
  }

  db.collection(SONGLISTS).add(objSonglist).then(docRef => {
    objSonglist.docId = docRef.id
    commit('loadSonglist', objSonglist)
    router.push('/editSonglist')
  })
    .catch(function (error) {
      console.error("Error adding songbook: ", error)
    })
}

export const editSonglist = ({ commit, state }) => {
  let objSonglist = {}
  if (state.loadedSonglist) {
    objSonglist = state.loadedSonglist
    db.collection(SONGLISTS).doc(objSonglist.docId).set(objSonglist).then(() => {
      commit('editSonglist', objSonglist)
      router.push('editSonglist')
    })
  }
}

export const deleteSonglist = ({ commit }, docId) => {
  commit('clearLoadedSonglist')
  db.collection(SONGLISTS).doc(docId).delete().then(() => {
    commit('deleteSonglist', docId)
  }).catch(err => {
    console.log(err);
  })
}

export const addToSonglist = ({ commit, state }, objSong) => {
  let objSonglist = state.loadedSonglist
  objSonglist.songs .push(objSong)
  commit('loadSonglist', objSonglist)
  db.collection(SONGLISTS).doc(state.loadedSonglist.docId).set(objSonglist).then (() => {
  }).catch(function (error) {
      console.error("Error adding song: ", error)
    })
}
